import UsersList from "./components/usersList";

export default function UsersAndAccess() {
  return <div className="w-full bg-background py-4 px-5 flex justify-center items-top min-h-ScreenWithNavbar">
    {/* <CreateUser /> */}
    <UsersList />
  </div>;
}
